enum ColorMaterialType {
  Metallic = 'metallic',
  Standard = 'standard',
  Special = 'special',
  Pastel = 'pastel',
}

export default ColorMaterialType;
